import React from 'react';

import FaqCollapsible from '@components/common/Collapsible/FaqCollapsible/FaqCollapsible';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Layout from '@components/lpc/Layout/Layout';
import MainPartners from '@components/lpc/PartnersNetwork/Partners/MainPartners/MainPartners';
import { partnerType } from '@propTypes/partnerTypes';
import partnersService from '@services/domain/Lpc/PartnersService';
import { isInternalServerError } from '@services/http/Http';

import css from './PartnersNetworkPage.module.scss';
import Custom500 from '../../500';

export type partnersNetworkPageProps = {
    internalError: boolean;
    partners: partnerType[];
    favoritePartners: partnerType[];
};
const PartnersNetworkPage = ({ internalError, partners, favoritePartners }: partnersNetworkPageProps) => {
    const { t } = useTranslateLpc(['lpc-partners-network', 'lpc-footer']);
    if (internalError) {
        return <Custom500 />;
    }
    const faq: { question: string | any; answer: string | any }[] = Array.from(
        { length: 2 },
        (_, index) => index + 1,
    ).map((index) => {
        return { question: t(`q&a.${index - 1}.question`), answer: t(`q&a.${index - 1}.answer`) };
    });

    return (
        <Layout>
            <div className={css.partnersNetworkPageWrapper}>
                <MainPartners partners={partners} favoritePartners={favoritePartners} />
                <FaqCollapsible title={t('faq.title')} subtitle={t('faq.subtitle')} cta={t('faq.cta')} content={faq} />
            </div>
        </Layout>
    );
};

export default PartnersNetworkPage;

export const getServerSideProps = async (ctx) => {
    let internalError = false;
    const partners = await partnersService.getAllPartners(ctx).catch((err) => {
        internalError = isInternalServerError(err);
    });
    const favoritePartners = await partnersService.getFavoritePartners(ctx);

    return {
        props: {
            internalError,
            partners,
            favoritePartners,
        },
    };
};
